import { CardInfo, ClaimModel, ClientUser, NspkProgramResidentObject } from '@/api'

export class ClaimForm implements ClaimModel {
  mainData: {
    snils: string
    oms?: string
    middleName?: string
    lastName: string
    gender: number
    firstName: string
    birthPlace: string
    birthDate: string
  }
  nspkData: {
    programResidentHash: string
    programResidentId: string
  }
  document: {
    series: string
    number: string
    issuedBy: string
    issueDate: string
    issueCode: string
    docType: number
  }
  contacts: {
    regAddress: string
    mobilePhone: string
    phone: string
    factAddress?: string
    temporaryRegAddress?: string
    emailAccept: boolean
    email: string
  }
  cardInfo: {
    cardNumber: string
    qrData?: string
    cardUuid?: string
  }

  constructor(user: ClientUser, cardToEdit?: CardInfo) {
    this.mainData = {
      snils: user.mainData?.snils ?? undefined,
      oms: user.mainData?.oms ?? undefined,
      middleName: user.mainData?.middleName ?? undefined,
      lastName: user.mainData?.lastName ?? undefined,
      firstName: user.mainData?.firstName ?? undefined,
      birthPlace: user.mainData?.birthPlace ?? undefined,
      birthDate: user.mainData?.birthDate?.replace(/(\d+)\.(\d+)\.(\d+)/, '$3-$2-$1') ?? undefined,
      gender: user.mainData?.gender ?? undefined,
      // citizenship: user.mainData?.citizenship ?? undefined,
    }
    this.document = {
      series: user.document?.series ?? undefined,
      number: user.document?.number ?? undefined,
      issuedBy: user.document?.issuedBy ?? undefined,
      issueDate: user.document?.issueDate?.replace(/(\d+)\.(\d+)\.(\d+)/, '$3-$2-$1') ?? undefined,
      issueCode: user.document?.issueCode ?? undefined,
      docType: user.document?.docType ?? undefined,
    }
    this.contacts = {
      regAddress: user.contacts?.regAddress ?? undefined,
      mobilePhone: user.contacts?.mobilePhone ?? undefined,
      phone: user.contacts?.phone ?? undefined,
      factAddress: user.contacts?.factAddress ?? undefined,
      temporaryRegAddress: user.contacts?.temporaryRegAddress ?? undefined,
      emailAccept: user.contacts?.emailAccept ?? undefined,
      email: user.contacts?.email ?? undefined,
    }
    this.cardInfo = {
      cardNumber: cardToEdit?.cardNumber ? `**** ***** **** ${cardToEdit?.cardNumber}` : undefined,
      qrData: cardToEdit?.qrData ?? undefined,
      cardUuid: cardToEdit?.cardUuid ?? undefined,
    }
  }

  get docType() {
    return this.document.docType.toString()
  }

  set docType(value: string) {
    this.document.docType = parseInt(value)
  }

  get filled() {
    return (
      this.cardInfo.cardNumber &&
      this.mainData.birthDate &&
      this.mainData.birthPlace &&
      this.mainData.firstName &&
      !isNaN(this.mainData.gender) &&
      this.mainData.lastName &&
      this.mainData.snils &&
      this.contacts.email &&
      this.contacts.mobilePhone &&
      this.contacts.regAddress &&
      !isNaN(this.document.docType) &&
      this.document.issueDate &&
      this.document.issuedBy &&
      this.document.number &&
      this.document.series
    )
  }

  get isEdit() {
    return Boolean(this.cardInfo?.cardUuid)
  }

  toSave(nspkData?: NspkProgramResidentObject): ClaimFormSerialize {
    return {
      nspkData,
      mainData: {
        ...this.mainData,
        birthDate: new Date(this.mainData.birthDate).toLocaleDateString('RU-ru', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
      },
      document: {
        ...this.document,
        issueDate: new Date(this.document.issueDate).toLocaleDateString('RU-ru', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
      },
      contacts: {
        ...this.contacts,
        factAddress: this.contacts.factAddress ? this.contacts.factAddress : '',
        temporaryRegAddress: this.contacts.temporaryRegAddress ? this.contacts.temporaryRegAddress : '',
      },
      cardInfo: {
        cardNumber: this.cardInfo.cardNumber.replaceAll(' ', ''),
        qrData: this.cardInfo.qrData,
        cardUuid: this.cardInfo.cardUuid,
      },
    }
  }
}

export type ClaimFormSerialize = Omit<ClaimForm, 'filled' | 'toSave' | 'isEdit' | 'docType'>
